import type { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { Button } from '@corratech/pylot-ui'
import { Cross } from '@components/icons'
import cn from 'classnames'
import s from './Confirm.module.scss'

export type ConfirmBoxType = {
    show: boolean
    closeConfirm: () => void
    handleAction?: () => void
    footer?: boolean
    className?: string
}

export const ConfirmBox: FC<ConfirmBoxType> = ({
    show,
    closeConfirm,
    handleAction,
    children,
    footer = true,
    className
}) => {
    const { t } = useTranslation('common')

    if (!show) return null

    return (
        <div className={cn(s['confirm-modal-box'], className)}>
            <div className={cn(s['confirm-overlay'], 'confirm-overlay')} />
            <div
                className={cn(
                    s['confirm-modal-inner'],
                    'confirm-modal-inner',
                    'animate-fade-in-down'
                )}
            >
                <div className={cn(s['modal-header'], 'modal-header')}>
                    <span
                        tabIndex={0}
                        role="button"
                        onClick={closeConfirm}
                        onKeyDown={closeConfirm}
                        className={s['close-btn']}
                    >
                        <Cross />
                    </span>
                </div>

                <div className={cn(s['modal-content'], 'modal-content')}>
                    {children}
                </div>
                {footer && (
                    <div className={cn(s['modal-footer'], 'modal-footer')}>
                        <Button
                            variant="primary"
                            onClick={closeConfirm}
                            className={s['confirm']}
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={handleAction}
                            className={s['delete']}
                        >
                            {t('Ok')}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}
